<div class="min-h-screen bg-section flex flex-col items-center justify-center p-6 relative overflow-hidden text-body-text selection:bg-btn/30">
  
  <!-- Botanical Decoration (Top Left) -->
  <div class="absolute -top-12 -left-12 w-48 h-48 sm:w-64 sm:h-64 md:w-96 md:h-96 opacity-60 pointer-events-none">
    <img src="amla-top-left.jpg" alt="Amla Branch" class="w-full h-full object-contain mix-blend-multiply aspect-square transform -rotate-12">
  </div>

  <!-- Botanical Decoration (Bottom Right) -->
  <div class="absolute -bottom-12 -right-12 w-56 h-56 sm:w-80 sm:h-80 md:w-[30rem] md:h-[30rem] opacity-60 pointer-events-none">
     <img src="amla-bottom-right.png" alt="Ashwagandha Root" class="w-full h-full object-contain mix-blend-multiply aspect-square transform rotate-12">
  </div>

  <!-- Main Content -->
  <div class="relative z-10 w-full max-w-2xl mx-auto flex flex-col items-center text-center space-y-6 md:space-y-8 animate-fade-in px-4">
    
    <!-- Logo/Brand -->
    <div class="space-y-4">
      <div class="w-32 sm:w-40 md:w-56 mx-auto transition-all duration-300">
        <img src="FINAL.png" alt="AARVYA" class="w-full h-auto drop-shadow-sm">
      </div>
      <div class="w-full h-px bg-gradient-to-r from-transparent via-btn to-transparent opacity-50"></div>
    </div>
    
    <!-- Tagline -->
    <p class="font-serif italic text-muted text-lg sm:text-xl md:text-2xl tracking-wide px-2">
      Ancient Wisdom. Modern Rituals.
    </p>

    <!-- Description -->
    <div class="max-w-md mx-auto space-y-3 sm:space-y-4 pt-2 sm:pt-4">
      <p class="text-heading leading-relaxed font-light text-base sm:text-lg px-2">
        A new era of Ayurvedic wellness is on the horizon.
        <br class="hidden sm:block">
        <span class="sm:hidden"> </span>
        Pure, natural, and crafted for your daily balance.
      </p>
    </div>

    <!-- Ingredients Divider -->
    <div class="w-full py-4 sm:py-6">
      <div class="w-full h-px bg-[#E5DDD5] relative flex items-center justify-center">
        <div class="absolute bg-section px-2 sm:px-4 text-muted font-serif italic text-xs sm:text-sm md:text-base text-center leading-tight">
          Amla • Moringa • Triphala • Beetroot • Ashwagandha
        </div>
      </div>
    </div>

    <!-- Launching Status -->
    <div class="space-y-4 sm:space-y-6 w-full flex flex-col items-center">
      <h2 class="text-3xl sm:text-4xl md:text-5xl font-serif text-heading italic">Launching Soon</h2>
      
      <!-- Action: Toggle Button -->
      <button 
        *ngIf="!isNotifyFormVisible"
        (click)="toggleNotifyForm()"
        class="px-8 sm:px-10 py-2.5 sm:py-3 bg-btn text-white font-serif text-base sm:text-lg tracking-wider rounded-sm shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 uppercase active:scale-95"
      >
        Notify Me
      </button>

      <!-- Action: Email Form -->
      <div *ngIf="isNotifyFormVisible" class="w-full max-w-sm animate-fade-in">
        <form [formGroup]="notifyForm" (ngSubmit)="submitNotify()" *ngIf="!isSuccess; else successMessage" class="space-y-3">
          <div class="flex flex-col sm:flex-row gap-3">
            <div class="flex-1">
              <input 
                type="email" 
                formControlName="email"
                placeholder="Enter your email" 
                class="w-full px-4 py-3 bg-white border text-body-text placeholder-muted/60 font-serif focus:outline-none transition-colors rounded-sm"
                [class.border-[#E5DDD5]]="!email?.touched || email?.valid"
                [class.border-red-300]="email?.invalid && email?.touched"
                [disabled]="isSubmitting"
              >
              <div *ngIf="email?.invalid && email?.touched" class="mt-1 text-xs text-red-500 font-sans">
                <span *ngIf="email?.hasError('required')">Email is required</span>
                <span *ngIf="email?.hasError('email')">Please enter a valid email address</span>
              </div>
            </div>
            <button 
              type="submit"
              class="px-6 py-3 bg-heading text-white font-serif tracking-wide rounded-sm hover:secondary-btn transition-colors uppercase text-sm sm:text-base flex items-center justify-center min-w-[120px] disabled:opacity-70 disabled:cursor-not-allowed"
              [disabled]="notifyForm.invalid || isSubmitting"
            >
              <span *ngIf="!isSubmitting">Get Notified</span>
              <span *ngIf="isSubmitting" class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
            </button>
          </div>

          <div *ngIf="errorMessage" class="p-3 bg-yellow-50 border border-yellow-200 rounded-sm text-sm text-yellow-700 mt-2 text-left">
            {{ errorMessage }}
          </div>

          <p class="text-xs text-muted font-serif italic opacity-80">
            Be the first to know when we bloom.
          </p>
        </form>

        <ng-template #successMessage>
          <div class="p-4 bg-green-50 border border-green-200 rounded-sm text-center">
            <p class="text-green-700 font-medium">🎉 Thank you! We'll be in touch soon.</p>
          </div>
        </ng-template>
      </div>

    </div>

  </div>

  <!-- Footer -->
  <div class="absolute bottom-4 sm:bottom-6 w-full text-center">
    <div class="flex items-center justify-center gap-2 sm:gap-4 text-muted text-[10px] sm:text-sm font-serif italic opacity-80 px-4">
      <span class="w-8 sm:w-12 h-px bg-btn"></span>
      Reconnect with Nature’s Wisdom
      <span class="w-8 sm:w-12 h-px bg-btn"></span>
    </div>
  </div>

</div>
